import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Components/Styles/LoginSingup.css';
import { useAuth } from '../Context/AuthContext';
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import { useCart } from '../Context/CartContext';

function Login() {
  const navigate = useNavigate();
  const { login, setUser, user } = useAuth();
  const { apiSyncLocalToBackend } = useCart();

  const [email, setEmail] = useState(''); /*REGISTER*/
  const [pseudo, setPseudo] = useState('');
  const [password, setPassword] = useState(''); /*REGISTER*/
  const [passwordConf, setPasswordConf] = useState(''); /*REGISTER*/
  const [motdep, setMotdep] = useState('');
  const [loginMessage, setLoginMessage] = useState('');
  const [registerMessage, setRegisterMessage] = useState(''); /*REGISTER*/

  const [showPasswordLogin, setShowPasswordLogin] = useState(false);
  const [showPasswordReg, setShowPasswordReg] = useState(false); /*REGISTER*/
  const [showPasswordRegConf, setShowPasswordRegConf] = useState(false); /*REGISTER*/

  const [isLogin, setIsLogin] = useState(true);
  const [isRightPanelActive, setIsRightPanelActive] = useState(false);

  const resetRegisterForm = () => {
    setEmail('');
    setPseudo('');
    setPassword('');
    setPasswordConf('');
  };
  const resetLoginForm = () => {
    setPseudo('');
    setMotdep('');
  };

  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    setLoginMessage('');
    setRegisterMessage('');

    try {
      const response = await fetch('/api/log.php', {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        credentials: 'include',
        body: new URLSearchParams({ pseudo, motdep }),
      });

      const data = await response.json();

      if (data.success) {
        setLoginMessage('Connexion réussie');
        const sessionRes = await fetch('/api/check_session.php', { credentials: 'include' });
        const sessionData = await sessionRes.json();

        if (sessionData.loggedIn) {
          setUser({
            id: sessionData.userId,
            username: sessionData.username,
            email: sessionData.email,
            role: sessionData.role
          });
          resetLoginForm();
          navigate('/');
        } else {
          setLoginMessage("La session n'a pas pu être validée.");
        }
      } else {
        setLoginMessage(data.message || 'Erreur inconnue');
      }
    } catch (error) {
      console.error(error);
      setLoginMessage('Erreur de connexion');
    }
  };

  const handleSubmitRegister = (e) => {
    e.preventDefault();
    setLoginMessage('');
    setRegisterMessage('');

    if (password !== passwordConf) {
      setRegisterMessage('Les mots de passe ne correspondent pas.');
      return;
    }

    const formData = new FormData();
    formData.append('email', email);
    formData.append('pseudo', pseudo);
    formData.append('mdp', password);
    formData.append('mdpconf', passwordConf);

    fetch('/api/reg.php', { method: 'POST', body: formData })
      .then(res => res.text())
      .then(text => {
        const data = JSON.parse(text);

        if (data.success) {
          setRegisterMessage('Inscription réussie ! Vous pouvez vous connecter.');
          setTimeout(() => {
            resetRegisterForm();
            setIsLogin(true);            // mobile
            setIsRightPanelActive(false); // desktop
          }, 800);
        } else {
          setRegisterMessage(data.message || 'MDP invalide : maj + chiffre + symbole requis');
        }
      })
      .catch(err => {
        console.error(err);
        setRegisterMessage("Erreur d'inscription");
      });
  };

  const handleSignUpClick = () => {
    resetLoginForm();
    setLoginMessage('');
    setIsRightPanelActive(true);
  };
  const handleSignInClick = () => {
    resetRegisterForm();
    setRegisterMessage('');
    setIsRightPanelActive(false);
  };

  useEffect(() => {
    const syncCartIfNeeded = async () => {
      const localCart = JSON.parse(localStorage.getItem("cart") || "[]");
      if (user?.id && localCart.length > 0) {
        await apiSyncLocalToBackend();
      }
    };
    syncCartIfNeeded();
  }, [user?.id]);

return <>
  <div className="formulaire">
    <div className={`container ${isRightPanelActive ? 'right-panel-active' : '' }`}>
      <div className="form-container sign-up-container">
        <form className='form' onSubmit={handleSubmitRegister}>
          <h1>Créer un compte</h1>
          <input className='input-design' type="text" value={pseudo} onChange={(e)=> setPseudo(e.target.value)}
          placeholder="Pseudo" required />
          <input className='input-design' type="email" value={email} onChange={(e)=> setEmail(e.target.value)}
          placeholder="Email" required />

          <div className="passinput"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '10px', width: '100%'}}>
            <input className='input-design' type={showPasswordReg ? 'text' : 'password' } value={password}
              onChange={(e)=> setPassword(e.target.value)} placeholder="Mot de passe" required />

            <span onClick={()=> setShowPasswordReg(prev => !prev)}> {showPasswordReg ?
              <FaRegEyeSlash /> :
              <FaRegEye />} </span>
          </div>

          <div className="passinput"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '10px', width: '100%'}}>
            <input className='input-design' type={showPasswordRegConf ? 'text' : 'password' } value={passwordConf}
              onChange={(e)=> setPasswordConf(e.target.value)} placeholder="Confirmer le mot de passe" required />

            <span onClick={()=> setShowPasswordRegConf(prev => !prev)}> {showPasswordRegConf ?
              <FaRegEyeSlash /> :
              <FaRegEye />} </span>
          </div>

          <button type="submit" className='submit-btn'>S'inscrire</button>
          {registerMessage && <p className="form-message">{registerMessage}</p>}
        </form>
      </div>
      <div className="form-container sign-in-container">
        <form className='form' onSubmit={handleSubmitLogin}>
          <h1>Se connecter</h1>
          <input className='input-design' type="text" value={pseudo} onChange={(e)=> setPseudo(e.target.value)}
          placeholder="Pseudo" required />
          <div className="passinput" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input className='input-design' type={showPasswordLogin ? 'text' : 'password' } value={motdep}
              onChange={(e)=> setMotdep(e.target.value)} placeholder="Mot de passe" required />
            <span onClick={()=> setShowPasswordLogin(prev => !prev)}> {showPasswordLogin ?
              <FaRegEyeSlash /> :
              <FaRegEye />} </span>
          </div>
          <a href="#">Mot de passe oublié ?</a>
          <button type="submit" className='submit-btn'>Se connecter</button>
          {loginMessage && <p className="form-message">{loginMessage}</p>}
        </form>
      </div>
      <div className="overlay-container">
        <div className="overlay">
          <div className="overlay-panel overlay-left">
            <h1>Te revoilà ?</h1>
            <p>Connecte-toi pour accèder à ton espace personnel</p>
            <button className="ghost" onClick={handleSignInClick}>Se connecter</button>
          </div>
          <div className="overlay-panel overlay-right">
            <h1>Nouveau chez nous ?</h1>
            <p>Inscris-toi pour démarrer ton aventure</p>
            <button className="ghost" onClick={handleSignUpClick}>S'inscrire</button>
          </div>
        </div>
      </div>
    </div>

    {/*VERSION MOBILE*/}
    <div className="mobile-login">
      <div className="mobile-toggle">
        <button className={isLogin ? 'active' : '' } onClick={()=> setIsLogin(true)}>Se connecter</button>
        <button className={!isLogin ? 'active' : '' } onClick={()=> setIsLogin(false)}>S’inscrire</button>
      </div>

      {isLogin ? (
      <form className="form" onSubmit={handleSubmitLogin}>
        <h1>Se connecter</h1>
        <input className='input-design' type="text" value={pseudo} onChange={(e)=> setPseudo(e.target.value)}
        placeholder="Pseudo" required />
        <div className="passinput">
          <input className='input-design' type={showPasswordLogin ? 'text' : 'password' } value={motdep} onChange={(e)=>
          setMotdep(e.target.value)} placeholder="Mot de passe" required />
          <span onClick={()=> setShowPasswordLogin(prev => !prev)}> {showPasswordLogin ?
            <FaRegEyeSlash /> :
            <FaRegEye />} </span>
        </div>
        <button type="submit" className='submit-btn'>Connexion</button>
        {loginMessage && <p className="form-message">{loginMessage}</p>}
      </form>
      ) : (
      <form className="form" onSubmit={handleSubmitRegister}>
        <h1>S’inscrire</h1>
        <input className='input-design' type="text" value={pseudo} onChange={(e)=> setPseudo(e.target.value)}
        placeholder="Pseudo" required />
        <input className='input-design' type="email" value={email} onChange={(e)=> setEmail(e.target.value)}
        placeholder="Email" required />
        <div className="passinput">
          <input className='input-design' type={showPasswordReg ? 'text' : 'password' } value={password} onChange={(e)=>
          setPassword(e.target.value)} placeholder="Mot de passe" required />
          <span onClick={()=> setShowPasswordReg(prev => !prev)}> {showPasswordReg ?
            <FaRegEyeSlash /> :
            <FaRegEye />} </span>
        </div>
        <div className="passinput">
          <input className='input-design' type={showPasswordRegConf ? 'text' : 'password' } value={passwordConf}
            onChange={(e)=> setPasswordConf(e.target.value)} placeholder="Confirmer le mot de passe" required />
          <span onClick={()=> setShowPasswordRegConf(prev => !prev)}> {showPasswordRegConf ?
            <FaRegEyeSlash /> :
            <FaRegEye />} </span>
        </div>
        <button type="submit" className='submit-btn'>S’inscrire</button>
        {registerMessage && <p className="form-message">{registerMessage}</p>}
      </form>
      )}
    </div>
  </div>
</>
}



export default Login;